import React from 'react';
import './recentWork.css';
import IMG1 from '../../assets/project1.png';
import IMG2 from '../../assets/project2.png';
import IMG3 from '../../assets/project3.png';
import IMG19 from "../../assets/portfolio1.png";
import IMG20 from "../../assets/portfolio2.png";
import IMG17 from "../../assets/portfolio3.png";
import IMG18 from "../../assets/portfolio4.png";
import IMG5 from "../../assets/portfolio5.png";
import IMG6 from "../../assets/portfolio6.png";
import IMG7 from "../../assets/portfolio7.png";
import IMG8 from "../../assets/portfolio8.png";
import IMG9 from "../../assets/portfolio9.png";
import IMG10 from "../../assets/portfolio10.png";
import IMG11 from "../../assets/portfolio11.png";
import IMG12 from "../../assets/portfolio12.png";
import IMG13 from "../../assets/portfolio13.png";
import IMG14 from "../../assets/portfolio14.png";
import IMG15 from "../../assets/portfolio15.png";
import IMG16 from "../../assets/portfolio16.png";

const projects = [
  {
    id: 1,
    image: IMG1,
    title: 'Sales of the summar collection',
    github: 'https://github.com/TopSecretStar/next-ecommerce-frontend',
    demo: 'https://next-ecommerce-frontend-three.vercel.app/',
  },
  {
    id: 2,
    image: IMG2,
    title: 'Summer Sale Stylish',
    github: 'https://github.com/TopSecretStar/ecommerce-website',
    demo: 'https://ecommerce-website-eta-snowy.vercel.app/',
  },
  {
    id: 3,
    image: IMG3,
    title: 'FriedShop',
    github: 'https://github.com/TopSecretStar/friendshop-frontend',
    demo: 'https://friedshop.vercel.app/',
  },
  {
    id: 15,
    image: IMG15,
    title: "Madamcoon Maine Coon Cattery NYC",
    // github: "https://github.com/jeffjiang13",
    // demo: "https://madamcoon.com/",
    live: "https://madamcoon.com/",
  },
  {
    id: 16,
    image: IMG16,
    title: "ChiqueChickShop",
    // github: "https://github.com/jeffjiang13",
    // demo: "https://chiquechickshop.com/",
    live: "https://chiquechickshop.com/",
  },
  {
    id: 13,
    image: IMG13,
    title: "Facebook Clone",
    // github: "https://github.com/albertboyd/facebook-clone",
    // demo: "https://albert-boyd-facebook.vercel.app/",
  },
  {
    id: 14,
    image: IMG14,
    title: "Instagram Clone",
    // github: "https://github.com/albertboyd/instagram-clone",
    // demo: "https://albert-boyd-ig.vercel.app",
  },
  {
    id: 19,
    image: IMG19,
    title: "Ecommerce with Strapi",
    // github: "https://github.com/albertboyd/top-ecommerce-frontend",
    // demo: "https://chiquechick-frontend.vercel.app/",
  },
  {
    id: 20,
    image: IMG20,
    title: "iShopper (with multi shop vendor)",
    // github: "https://github.com/albertboyd/ishopper",
    // demo: "https://albert-boyd-ecommerce-5.vercel.app/",
  },
  {
    id: 17,
    image: IMG17,
    title: "ShopWise (with Admin Panel)",
    // github: "https://github.com/albertboyd/ecommerce-3",
    // demo: "https://albert-boyd-ecommerce-3.vercel.app/",
  },
  {
    id: 18,
    image: IMG18,
    title: "Ecommerce with Strapi",
    // github: "https://github.com/albertboyd/react-ecommerce",
    // demo: "https://albert-boyd-react-ecommerce.vercel.app/",
  },
  {
    id: 5,
    image: IMG5,
    title: "Ecommerce with Admin Panel",
    // github: "https://github.com/albertboyd/ecommerce-4",
    // demo: "https://albert-boyd-ecommerce-4.vercel.app/",
  },
  {
    id: 6,
    image: IMG6,
    title: "Nike Store Clone",
    // github: "https://github.com/albertboyd/ecommerce-store",
    // demo: "https://albert-boyd-ecommerce-store.vercel.app/",
  },
  {
    id: 7,
    image: IMG7,
    title: "CryptoKet",
    // github: "https://github.com/albertboyd/cryptoket-v2",
    // demo: "https://albert-boyd-cryptoket-v2.vercel.app/",
  },
  {
    id: 8,
    image: IMG8,
    title: "TikTok Clone",
    // github: "https://github.com/albertboyd/tiktok",
    // demo: "https://albert-boyd-tiktok.vercel.app/",
  },
  {
    id: 9,
    image: IMG9,
    title: "Cinema",
    // github: "https://github.com/albertboyd/cinema",
    // demo: "https://albert-boyd-cinema.vercel.app/",
  },
  {
    id: 10,
    image: IMG10,
    title: "Pokedex",
    // github: "https://github.com/albertboyd/pokedex",
    // demo: "https://albert-boyd-pokedex.vercel.app/",
  },
  {
    id: 11,
    image: IMG11,
    title: "Amazon Clone",
    // github: "https://github.com/albertboyd/amazon",
    // demo: "https://albert-boyd-amazon.vercel.app/",
  },
  {
    id: 12,
    image: IMG12,
    title: "MovieNight",
    // github: "https://github.com/albertboyd/movie-night",
    // demo: "https://albert-boyd-movie-night.vercel.app/",
  },
];

const RecentWork = () => {
  return (
    <section id='recentWork'>
      <h5>My Recent Work</h5>
      <h2>Projects</h2>

      <div className='container recentWork__container'>
        {projects.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className='recentWork__item'>
              <div className='recentWork__item-image'>
                <img src={image} alt='title' />
              </div>
              <h3>{title}</h3>
              <div className='recentWork__item-cta'>
                <a
                  href={github}
                  className='btn'
                  target='_blank'
                  rel='noreferrer'
                >
                  GitHub
                </a>
                <a
                  href={demo}
                  className='btn btn-primary'
                  target='_blank'
                  rel='noreferrer'
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default RecentWork;
